export default {
  dapp: {
    list: {
      header: {
        rank: "#",
        name: "Name",
        voteReceived: "Vote Received",
        blockProducedCount: "Block Prod. Nb",
        transactionProcessedCount: "Transac. Prod. Nb"
      }
    }
  }
}
